<template>
  <div class="flex flex-col justify-center items-center">
    <a :href="teacher.teacherPage">
      <BaseAvatarTeacher
        :id="teacher.username"
        :size="size"
        :alt="alt"
        :img-url="teacher.picture"
      />
    </a>
    <BaseButton
      v-if="showBtn"
      :label="$t('common.actions.see_profile')"
      flat
      size="sm"
      class="mt-[10px]"
      tag="a"
      :to="teacher.teacherPage"
    />
  </div>
</template>
<script>
export default {
  name: 'TeacherListItemsAvatar',
  inject: ['teacher'],
  props: {
    showBtn: {
      type: Boolean,
      default: true
    },
    size: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    alt () {
      return this.teacher?.picture?.alt
    }
  }
}
</script>

<style scoped lang="scss">

</style>
